import { FC } from "react"
import { useGetUserGameStatisticsQuery } from "store/apis/userAPI"
import { usePersonalDailyDeals } from "hooks/usePersonalDailyDeals/usePersonalDailyDeals"
import { OutlinedTextV4 } from "ui/OutlinedText-v4/OutlinedText"
import { exclamationMarkIcon } from "assets/icons"
import styles from "../../index.module.scss"

export const WalletDealBadge: FC = () => {
  const { personalDeal } = usePersonalDailyDeals()
  const { data: userGameStatistics } = useGetUserGameStatisticsQuery()

  if (!userGameStatistics?.transactions) {
    return null
  }

  return (
    <>
      <OutlinedTextV4 className={styles.FooterMenuItem_personalDeal}>
        {personalDeal?.dailySailId &&
          `-${personalDeal?.dailySailId?.discountPercent}%`}
      </OutlinedTextV4>
      {!personalDeal?.dailySailId && (
        <div className={styles.FooterMenuItem_personalDeal_indicator}>
          <img src={exclamationMarkIcon} alt="" />
        </div>
      )}
    </>
  )
}
